import {
  Directive,
  ElementRef,
  forwardRef,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import CodeFlask from 'codeflask';
import { indent } from 'indent.js';

interface Flask {
  new (selectorOrElement: string | HTMLElement, options: FlaskOptions): any;

  onUpdate(callback: (code: string) => void): void;
  updateCode(code: string): void;
  getCode(): string;
}

interface FlaskOptions {
  language: string;
  lineNumbers: boolean;
  rtl: boolean;
  readonly: boolean;
}

@Directive({
  selector: '[mdCodeFlask]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CodeFlaskDirective),
      multi: true,
    },
  ],
})
export class CodeFlaskDirective implements OnInit, ControlValueAccessor {
  @Input() language = 'html';

  @HostBinding('style.position') cssPosition = 'relative';
  @HostBinding('style.height.px') @Input() cssHeight = 400;

  // @ts-expect-error
  flask: Flask;

  get model() {
    return this.modelValue;
  }
  set model(value: string) {
    if (value !== this.modelValue) {
      this.modelValue = value;
      this.onChangeCallback(value);
    }
  }

  // @ts-expect-error
  private modelValue: string;

  onChangeCallback = (_: any) => {};

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.flask = new CodeFlask(this.elementRef.nativeElement, {
      language: this.language,
      lineNumbers: true,
    }) as unknown as Flask;

    this.flask.onUpdate((code: string) => {
      this.model = code;
    });
  }

  writeValue(value: string) {
    // eslint-disable-next-line no-param-reassign
    value = indent.html(value, {
      // indentHtmlTag: true,
      tabString: '  ',
    });
    this.modelValue = value;
    this.flask.updateCode(value);
  }

  registerOnChange(fn: (_: any) => void) {
    this.onChangeCallback = fn;
  }

  registerOnTouched() {}
}
